import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const SubscriptionPlanBenefit = (props: { planBenefit: string[] }) => {
  const { planBenefit } = props;
  const { t, ready } = useTranslation();
  if (!ready || !planBenefit || planBenefit.length === 0) return null;
  return (
    <Row className="my-4 justify-content-center">
      <Col xs={12} md={8} lg={6} xl={5}>
        <div className="subscription-plan-benefits">
          <h4 className="benefits-heading">{t("subscription.subscriptionInfo.whatincluded")}</h4>
          <div className="benefits-grid">
            {planBenefit.map((benefit: string, index: number) => (
              <div key={index} className="benefit-row">
                <span className="benefit-check">✓</span>
                <span className="benefit-text">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  );
};
